// Fields that another field's editor writes on its own.
//
// The LocationField takes over an `address` sibling: the map reverse geocodes
// what the crosshairs point at and writes it back (see its `address` watcher).
// A second, plain input for the same field would fight the map - the editor
// disables it instead.
export function managedFieldIds(contentType) {
	const fields = contentType?.fields ?? []
	if (fields.some(f => f.type == 'Location') && fields.some(f => f.id == 'address'))
		return [ 'address' ]
	return []
}
